import React from 'react'

import {LexicalEditor} from "lexical"
import UI5ControlButton from "../../../../../layout/app-controls/buttons/button/button"
import {ButtonSize} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import AiChatModule from "../../ai-chat"
import {lexicalAddTextMarkdown} from "../../../../gd-components/editor/actions/insert-text-markdown"
// import writeWithAiToChat from "../../actions/convert-to-chat"
// import AppLoader_AIChat from "../../../../../app/ai-chat/app-loader"
// import {lexicalGetSelectedText} from "../../../../gd-components/editor/actions/get-selected-text"

type Props = {
    className?  : string

    module      : AiChatModule
    editor      : LexicalEditor

    onBack      : func
}

export default function WriteWithAi_ActionButtons(props: Props) {

    const onInsertClick = () => {
        const lastMessage = props.module.currentAiMessage
        lexicalAddTextMarkdown(props.editor, lastMessage?.message ? lastMessage?.message: "")
    }

    const onCopyClick = () => {
        gd.utils.copyToClipboard(props.module.currentAiMessage?.message)
    }

    /*const onSaveClick = () => {
        if (!props.module.currentAIChat) {
            throw Error(`Failed to save as chat ${props.module.currentAiMessage}`)
        }

        writeWithAiToChat(props.module.currentAIChat.id)

        gd.layout.right.loadAndRun(AppLoader_AIChat)
    }*/

    const showButtons = !!props.module.currentAiMessage
    const showReplaceButton = !!props.module.chatContext?.selectedText //lexicalGetSelectedText(props.editor)

    const classes = Classes(props.className, "flex-row-left-center")
    const buttonClasses = Classes( "action-button m-r-8", {"invisible": !showButtons})

    // console.log("!!!", buttonClasses)


    return (
        <div className={classes}>
            {/*<UI5ControlButton*/}
            {/*    className   = {buttonClasses}*/}
            {/*    iconClass   =  "i5-long-arrow-left"*/}
            {/*    label       = "Back"*/}
            {/*    size        = {ButtonSize.SMALLER}*/}
            {/*    onClick     = {props.onBack}*/}
            {/*/>*/}

            <UI5ControlButton
                className   = {buttonClasses}
                iconClass   =  "i5-clone"
                label       = "Copy"
                size        = {ButtonSize.SMALLER}
                onClick     = {onCopyClick}
            />

            {showReplaceButton &&
                <UI5ControlButton
                    className   = {buttonClasses}
                    iconClass   =  "ii5-actions"
                    label       = "Replace"
                    size        = {ButtonSize.SMALLER}
                    onClick     = {onInsertClick}
                />
            }

            <UI5ControlButton
                className   = {buttonClasses}
                iconClass   =  "i5-minimize"
                label       = "Insert below"
                size        = {ButtonSize.SMALLER}
                onClick     = {onInsertClick}
            />



            {/*<UI5ControlButton*/}
            {/*    iconClass   =  "ii5-lightning"*/}
            {/*    label       = "Save & continue in Ask AI"*/}
            {/*    size        = {ButtonSize.SMALLER}*/}
            {/*    onClick     = {onSaveClick}*/}
            {/*/>*/}


        </div>
    )
}
